import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import { GetFeedbackQuestionAPIResponse, SubmitAssessmentQuestionFeedbackInput } from 'types';

const baseUrl = `${API_ENDPOINT}/feedback-question-response`;

export const createFeedbackQuestionResponse = async (
	payload: SubmitAssessmentQuestionFeedbackInput,
): Promise<GetFeedbackQuestionAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}`, payload);
	return response.data;
};
